import { createEvent, restore, sample } from 'effector'
import {
  BudgetItemListRequest,
  BudgetItemListResponse,
  BudgetItemType,
} from './types'
import { fx } from '../../../../libs'

export const budgetItemListMounted = createEvent<BudgetItemListRequest>()

export const getBudgetItemList = fx<void, BudgetItemListResponse>({
  method: 'GET',
  url: '/finance/budget_item',
})

export const $budgetItemList = restore<BudgetItemType[]>(
  getBudgetItemList.doneData.map((a) => a.body.items),
  [],
)

export const $totalBudgetItemList = restore(
  getBudgetItemList.doneData.map((a) => a.body.total),
  0,
)

sample({
  // @ts-ignore
  clock: budgetItemListMounted,
  fn: ({ limit, page, orderBy, orderDirection }) => {
    if (orderDirection === 'descend') {
      orderDirection = '-'
    } else if (orderDirection === 'ascend') {
      orderDirection = ''
    }

    let query = {
      limit,
      page,
    }

    if (orderBy) {
      // @ts-ignore
      query['order'] = orderDirection + orderBy
    }

    return {
      url: `/finance/budget_item`,
      query,
    }
  },
  target: getBudgetItemList,
})
